export default __webpack_public_path__ + "static/media/Price_Quotation.795c6d3e.png";